import type { ReactNode } from "react";

export function Panel({
  title,
  action,
  children,
  className = "",
}: {
  title?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`rounded-lg border border-bg-line bg-bg-panel ${className}`}
    >
      {(title || action) && (
        <header className="flex items-center justify-between px-5 py-3 border-b border-bg-line">
          {title ? (
            <h2 className="text-[11px] uppercase tracking-[0.18em] text-ink-dimmer">
              {title}
            </h2>
          ) : (
            <span />
          )}
          {action}
        </header>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export function StatTile({
  label,
  value,
  hint,
}: {
  label: string;
  value: ReactNode;
  hint?: string;
}) {
  return (
    <div className="rounded-lg border border-bg-line bg-bg-panel p-4">
      <div className="text-[10px] uppercase tracking-[0.18em] text-ink-dimmer">
        {label}
      </div>
      <div className="mt-2 font-display text-3xl font-light text-ink">
        {value}
      </div>
      {hint ? <div className="text-xs text-ink-dim mt-1">{hint}</div> : null}
    </div>
  );
}

export function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <div className="px-6 pt-6 pb-3">
      <h1 className="font-display text-2xl font-light text-ink">{title}</h1>
      {subtitle ? <p className="text-sm text-ink-dim mt-1">{subtitle}</p> : null}
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex items-center gap-2 text-sm text-ink-dim">
      <span className="w-3 h-3 rounded-full bg-accent-cyan animate-pulse" />
      Loading…
    </div>
  );
}
